import React from "react";

import { NavigateCard } from "../../../components/cards";

import * as S from "./styles";

import IProps from "./props";
import { IconName } from "../../../components/cards/navigate-card/props";

interface ICard {
  icon: IconName;
  title: string;
  to: string;
  description: React.ReactNode;
  invertColor?: boolean;
}

const cards: ICard[] = [
  {
    icon: "nf",
    title: "Emitir nota",
    to: "issue/create",
    description: "Nota fiscal Avulsa",
  },
  {
    icon: "invoice",
    title: "Emitir Invoice",
    to: "invoice/create",
    description: "Invoice",
  },
  {
    icon: "invoice",
    title: "Emitir nota exterior",
    to: "exterior/create",
    description: "Nota Exterior",
    invertColor: true,
  },
  {
    icon: "documents",
    title: "Notas Recorrentes",
    to: "recurrency",
    description: "Notas Recorrentes",
  },
];

const HomeDeveloper: React.FC<IProps> = ({ user }) => (
  <S.Container>
    <S.Title>
      Olá {user?.name}, seja bem vindo! <hr />
    </S.Title>
    <S.Cards>
      {cards.map((card) => (
        <NavigateCard {...card}>{card.description}</NavigateCard>
      ))}
    </S.Cards>
  </S.Container>
);
export default HomeDeveloper;
